// routes
import { useEffect } from 'react';
import { PATH_ADMIN, PATH_USER } from '../../../routes/paths';
// components
import Label from '../../../components/Label';
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';
import useAuth from '../../../hooks/useAuth';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const getIconfy = (name) => <Iconify icon={name} width={22} height={22} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),

  // ---------------------------------------
  // Student Icons
  jobs: getIconfy('eva:briefcase-fill'),
  events: getIconfy('carbon:events'),
  opportunities: getIconfy('maki:college'),
  placements: getIconfy('fluent:people-audience-24-filled'),
  internships: getIconfy('fluent:people-team-24-filled'),
  resume: getIconfy('mingcute:document-line'),
  StudentSettings: getIconfy('eva:settings-fill'),
  studentCareerTrack: getIconfy('eva:arrowhead-up-outline'),
  ctroadmap: getIconfy('streamline:arrow-roadmap'),
  test: getIconfy('material-symbols:quiz'),
  // Student CH
  careerHubHome: getIconfy('eva:home-outline'),
  personalityTest: getIconfy('icon-park-outline:thinking-problem'),
  mockInterview: getIconfy('material-symbols:frame-person-mic'),

  // ---------------------------------------
  // Univeristy Icons
  addStudent: getIconfy('eva:person-add-fill'),
  groups: getIconfy('eva:people-fill'),
  studentActivity: getIconfy('eva:activity-fill'),
  uniJobs: getIconfy('eva:briefcase-fill'),
  studentDetails: getIconfy('eva:person-fill'),
  univeristyEvent: getIconfy('material-symbols:event'),
  uniWorkshops: getIconfy('material-symbols:computer-outline'),
  upgrade:getIconfy('eva:arrowhead-up-outline'),
  add:getIconfy('ic:baseline-add'),

  // ---------------------------------------
  // Company Icons
  newJobs: getIconfy('eva:archive-fill'),
  newJobPosting: getIconfy('ion:create-outline'),
  Applicants: getIconfy('et:profile-male'),


  // TPO
  uniListing: getIconfy('la:university'),
  recListing: getIconfy('hugeicons:permanent-job'),
  howit: getIconfy('material-symbols:help'),
  myContacts : getIconfy('material-symbols:contacts'),
  community: getIconfy('wpf:chat'),
  myUniversity : getIconfy('hugeicons:university'),
};

const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRON || '';

const adminNavConfig = [
  {
    subheader: 'Home',
    items: [
      {
        roles: ['org'],
        title: 'dashboard',
        path: PATH_ADMIN.dashboard,
        icon: ICONS.dashboard,
      },
      {
        roles: ['org'],
        title: 'Check Ins',
        path: PATH_ADMIN.checkIns,
        icon: ICONS.calendar,
      },
      {
        roles: ['org'],
        title: 'Members',
        path: PATH_ADMIN.members.root,
        icon: ICONS.user,
      },
      {
        roles: ['org'],
        title: 'Meeting Room',
        path: PATH_ADMIN.meetingRoomManagement.root,
        icon: ICONS.booking,
      }
    ],
  },
  {
    subheader: 'Settings',
    items: [
      {
        roles: ['org'],
        title: 'Space Management',
        path: PATH_ADMIN.SpaceManagement,
        icon: ICONS.recListing
      },
      {
        roles: ['org'],
        title: 'Plan Management',
        path: PATH_ADMIN.planManagement.root,
        icon: ICONS.add
      },
      {
        roles: ['org'],
        title: 'Inventory Management',
        path: PATH_ADMIN.inventoryManagement.root,
        icon: ICONS.add
      }
    ],
  },
  {
    subheader: 'For You',
    items: [
      {
        roles: ['org'],
        title: 'Settings',
        path: 'user/settings',  // Note: This path wasn't provided in PATH_ADMIN, kept as is
        icon: ICONS.StudentSettings,
      },
    ],
  },
];


const userNavConfig = [
  {
    subheader: 'Home',
    items: [
      {
        roles: ['user'],
        title: 'dashboard',
        path: PATH_USER.dashboard,
        icon: ICONS.dashboard,
      },
    ],
    },
]


const navConfig = [
  {
    roles: ['org'],
    items: adminNavConfig,
  },
  {
    roles: ['user'],
    items: userNavConfig,
  },
];

export default navConfig;
